'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { fetchBlogs } from '@eliadmin/core/src/api/blogs/blogs-api';
import { CacheKey } from '@eliadmin/core/src/api/constants';
import { SearchBarBlog } from '@eliadmin/core/src/components/blog/search-bar/search-bar-blog';
import { useSearchBar } from '@eliadmin/core/src/hooks/search-bar/use-search-bar';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { BlogSearchBarInner } from './blog-search-bar-inner';

export const BlogSearchBar = () => {
  const locale = useLocaleStore(s => s.currentLocale);

  const { items, isLoading, searchQuery, setSearchQuery } = useSearchBar({
    fetchFn: query => fetchBlogs({ locale, query: { results: 5, search: query } }),
    cacheKey: CacheKey.BLOGS,
    mapData: (data, debouncedSearch) =>
      data.data.map((blog: Blog & { id: number }) => (
        <SearchBarBlog key={`${blog.id}`} blog={blog} searchQuery={debouncedSearch} />
      )),
  });

  return (
    <BlogSearchBarInner
      items={items}
      isLoading={isLoading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      disableSidebar
    />
  );
};
